export const GET_COUPON_SMS_COUNTDOWN = 'GET_COUPON_SMS_COUNTDOWN';
export const ADMIN_LOGIN_SMS_COUNTDOWN = 'ADMIN_LOGIN_SMS_COUNTDOWN';
export const JOIN_US_SMS_COUNTDOWN = 'JOIN_US_SMS_COUNTDOWN';
